import React from "react";
import "./Utils.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faMailBulk} from "@fortawesome/free-solid-svg-icons";
import {faGithub, faTwitter} from "@fortawesome/free-brands-svg-icons";
import {SectionProps} from "./Section";
import BoxEffect from "./BoxEffect";
import CopyTextButton from "./CopyTextButton";


const ContactSection:React.FC<SectionProps> = (props)=> {
    return(
        <div className={"SectionBase"}>
            <div className={"SectionContent"}>
                <BoxEffect isActive={props.isActive} delay={0.0}>
                    <div className={"SectionTitle"}>
                        Contact
                    </div>
                </BoxEffect>
                <BoxEffect isActive={props.isActive} delay={0.125}>
                    <div className={"SectionSubtitle"}>
                        連絡・ご依頼など
                    </div>
                </BoxEffect>
                <div className={"Padding10"}>
                    <div className={"SectionMenuWindow"}>
                        <div style={{display:"flex"}}>
                            <FontAwesomeIcon icon={faMailBulk}/>　　<a href="mailto:ryu1999827@gmail.com">ryu1999827@gmail.com</a>
                        </div>
                        <div style={{display:"flex"}}>
                            <FontAwesomeIcon icon={faTwitter}/>　　<a href="https://twitter.com/lucknknock" target="_blank">@lucknknock</a>
                        </div>
                        <div style={{display:"flex"}}>
                            <FontAwesomeIcon icon={faGithub}/>　　<a href="https://github.com/Hirai0827" target="_blank">github</a>
                        </div>
                    </div>
                </div>
                <div className={"Padding10"}>
                </div>
            </div>
        </div>
    )
}

export default ContactSection;